// extracted by mini-css-extract-plugin
export default {"Header":"styles_Header_gysIT","HeaderTitle":"styles_HeaderTitle_i8zsH","HeaderContent":"styles_HeaderContent_K39EQ"};